// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Oswald:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General Styles */
/* General Styles */
;

.broucher-container {
  font-family: Arial, sans-serif;
  padding: 20px;
  background-color: hsl(0, 0%, 98%);
  text-align: center;
  margin: 0 auto;
 
}

.broucher-header h1 {
  font-size: 32px;
  color: #011103f1;
  margin-bottom: 10px;
  order:1;
margin-left:5%;
margin-top:100px;
}

.broucher-cards {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 20px; /* Space between cards */
  margin-left: 5%;
  margin-right:5%;
  margin-bottom:30px;
}
/* Brochure Card */
.broucher-card {
  background: #AC5C00;
  border-radius: 12px;
  width: 300px;
  height: 400px;
  padding: 20px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  box-shadow: 0 6px 12px rgba(30, 219, 233, 0.1);
  transition: transform 0.3s ease;
  font-family: 'Oswald', sans-serif;
}

.broucher-card:hover {
  transform: scale(1.05);
}

/* Top Description */
.card-top-description {
  font-size: 22px;
  font-weight: 200;
  color: white;
  text-align: left;
  margin-top:20px;
  font-family: 'Oswald', sans-serif;
}

/* Hexagon Design */
/* Hexagon Design */
.hexagon {
  width: 180px;
  height: 180px;
  clip-path: polygon(
    50% 0%, 
    95% 22%, 
    95% 78%, 
    50% 100%, 
    5% 78%, 
    5% 22%
  ); /* Smoothened edges by adjusting the percentages */
  background: #ffffff;
  overflow: hidden;
  position: relative;
  margin: 0 auto;
  margin-right: 5px;
  border-radius: 105px; /* Adds smoothness to the edges */
}

.hexagon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  
}

/* Brochure Info */
.broucher-info h2 {
  font-size: 24px;
  color: white;
  text-align: left;
  margin-top: -300px;
  white-space: nowrap; /* Prevent the text from wrapping */
}


/* Bottom Description */
.card-bottom-description {
  font-size: 22px;
  font-weight: 200;
  color: white;
  text-align: left;
  order:2;
}

/* Download Button */
.download-button {
  position: absolute;
  bottom: 20px;
  right: 20px;
  background-color: #dce7dc;
  color: #fff;
  text-decoration: none;
  border-radius: 4px;
  font-size: 40px;
  padding: 10px 16px;
  transition: background-color 0.3s ease;
}
.download-text {
  margin-top: 25px;
  font-size: 16px;
  color: #ecf1ec; /* Text color */
  font-weight: 300;
  text-align: center;
}
.download-button:hover {
  background-color: #50b9b9;
}
/* Download Button with Downward Arrow */
.download-icon {
  position: absolute;
  bottom: 30px;
  right: 30px;
  color: #ecf1ec; /* Icon color */
  font-size: 50px; /* Adjust the icon size */
  transition: color 0.3s ease;
}

.download-icon:hover {
  color: #0d8f3f; /* Icon color on hover */
}

/* Mobile View */
@media (max-width: 768px) {
  .broucher-cards {
    flex-direction: column; /* Stack cards vertically */
    align-items: center;
    gap: 20px;
    padding: 10px;
  }

  .broucher-card {
    width: 90%; /* Adjust width for mobile */
    padding: 15px;
    text-align: center; /* Center-align text */
  }

  .broucher-header h1 {
    font-size: 28px;
    color: #011103f1;
    margin-bottom: 10px;
    order:1;
  margin-left:5%;
  margin-top:100px;
  }
  .broucher-info h2,
  .card-top-description {
    text-align: center;
  }

  .hexagon {
    margin: 15px auto; /* Center hexagon on mobile */
    margin-right: 10px;
  }

  .card-bottom-description {
    text-align: left; /* Left-align bottom description */
    margin-top: 10px;
    width: 100%;
  }

  .download-button {
    align-self: flex-end; /* Align download button to the right */
    margin-top: 10px;
  }
  .broucher-info h2
  {
    font-size: 20px;
  }
 
}
`, "",{"version":3,"sources":["webpack://./src/components/Broucher/Broucher.css"],"names":[],"mappings":"AAAA,mBAAmB;AAEnB,mBAAmB;;;AAGnB;EACE,8BAA8B;EAC9B,aAAa;EACb,iCAAiC;EACjC,kBAAkB;EAClB,cAAc;;AAEhB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,OAAO;AACT,cAAc;AACd,gBAAgB;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,SAAS,EAAE,wBAAwB;EACnC,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;AACA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;EACvB,8CAA8C;EAC9C,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA,mBAAmB;AACnB,mBAAmB;AACnB;EACE,YAAY;EACZ,aAAa;EACb;;;;;;;GAOC,EAAE,kDAAkD;EACrD,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,oBAAoB,EAAE,iCAAiC;AACzD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,OAAO;;AAET;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB,EAAE,mCAAmC;AAC1D;;;AAGA,uBAAuB;AACvB;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,OAAO;AACT;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc,EAAE,eAAe;EAC/B,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,cAAc,EAAE,eAAe;EAC/B,eAAe,EAAE,yBAAyB;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,cAAc,EAAE,wBAAwB;AAC1C;;AAEA,gBAAgB;AAChB;EACE;IACE,sBAAsB,EAAE,2BAA2B;IACnD,mBAAmB;IACnB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,UAAU,EAAE,4BAA4B;IACxC,aAAa;IACb,kBAAkB,EAAE,sBAAsB;EAC5C;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,OAAO;EACT,cAAc;EACd,gBAAgB;EAChB;EACA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB,EAAE,6BAA6B;IAChD,kBAAkB;EACpB;;EAEA;IACE,gBAAgB,EAAE,kCAAkC;IACpD,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,oBAAoB,EAAE,uCAAuC;IAC7D,gBAAgB;EAClB;EACA;;IAEE,eAAe;EACjB;;AAEF","sourcesContent":["/* General Styles */\n@import url('https://fonts.googleapis.com/css2?family=Oswald:wght@300;400;500;600;700&display=swap');\n/* General Styles */\n;\n\n.broucher-container {\n  font-family: Arial, sans-serif;\n  padding: 20px;\n  background-color: hsl(0, 0%, 98%);\n  text-align: center;\n  margin: 0 auto;\n \n}\n\n.broucher-header h1 {\n  font-size: 32px;\n  color: #011103f1;\n  margin-bottom: 10px;\n  order:1;\nmargin-left:5%;\nmargin-top:100px;\n}\n\n.broucher-cards {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 20px; /* Space between cards */\n  margin-left: 5%;\n  margin-right:5%;\n  margin-bottom:30px;\n}\n/* Brochure Card */\n.broucher-card {\n  background: #AC5C00;\n  border-radius: 12px;\n  width: 300px;\n  height: 400px;\n  padding: 20px;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n  box-shadow: 0 6px 12px rgba(30, 219, 233, 0.1);\n  transition: transform 0.3s ease;\n  font-family: 'Oswald', sans-serif;\n}\n\n.broucher-card:hover {\n  transform: scale(1.05);\n}\n\n/* Top Description */\n.card-top-description {\n  font-size: 22px;\n  font-weight: 200;\n  color: white;\n  text-align: left;\n  margin-top:20px;\n  font-family: 'Oswald', sans-serif;\n}\n\n/* Hexagon Design */\n/* Hexagon Design */\n.hexagon {\n  width: 180px;\n  height: 180px;\n  clip-path: polygon(\n    50% 0%, \n    95% 22%, \n    95% 78%, \n    50% 100%, \n    5% 78%, \n    5% 22%\n  ); /* Smoothened edges by adjusting the percentages */\n  background: #ffffff;\n  overflow: hidden;\n  position: relative;\n  margin: 0 auto;\n  margin-right: 5px;\n  border-radius: 105px; /* Adds smoothness to the edges */\n}\n\n.hexagon img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  position: absolute;\n  top: 0;\n  left: 0;\n  \n}\n\n/* Brochure Info */\n.broucher-info h2 {\n  font-size: 24px;\n  color: white;\n  text-align: left;\n  margin-top: -300px;\n  white-space: nowrap; /* Prevent the text from wrapping */\n}\n\n\n/* Bottom Description */\n.card-bottom-description {\n  font-size: 22px;\n  font-weight: 200;\n  color: white;\n  text-align: left;\n  order:2;\n}\n\n/* Download Button */\n.download-button {\n  position: absolute;\n  bottom: 20px;\n  right: 20px;\n  background-color: #dce7dc;\n  color: #fff;\n  text-decoration: none;\n  border-radius: 4px;\n  font-size: 40px;\n  padding: 10px 16px;\n  transition: background-color 0.3s ease;\n}\n.download-text {\n  margin-top: 25px;\n  font-size: 16px;\n  color: #ecf1ec; /* Text color */\n  font-weight: 300;\n  text-align: center;\n}\n.download-button:hover {\n  background-color: #50b9b9;\n}\n/* Download Button with Downward Arrow */\n.download-icon {\n  position: absolute;\n  bottom: 30px;\n  right: 30px;\n  color: #ecf1ec; /* Icon color */\n  font-size: 50px; /* Adjust the icon size */\n  transition: color 0.3s ease;\n}\n\n.download-icon:hover {\n  color: #0d8f3f; /* Icon color on hover */\n}\n\n/* Mobile View */\n@media (max-width: 768px) {\n  .broucher-cards {\n    flex-direction: column; /* Stack cards vertically */\n    align-items: center;\n    gap: 20px;\n    padding: 10px;\n  }\n\n  .broucher-card {\n    width: 90%; /* Adjust width for mobile */\n    padding: 15px;\n    text-align: center; /* Center-align text */\n  }\n\n  .broucher-header h1 {\n    font-size: 28px;\n    color: #011103f1;\n    margin-bottom: 10px;\n    order:1;\n  margin-left:5%;\n  margin-top:100px;\n  }\n  .broucher-info h2,\n  .card-top-description {\n    text-align: center;\n  }\n\n  .hexagon {\n    margin: 15px auto; /* Center hexagon on mobile */\n    margin-right: 10px;\n  }\n\n  .card-bottom-description {\n    text-align: left; /* Left-align bottom description */\n    margin-top: 10px;\n    width: 100%;\n  }\n\n  .download-button {\n    align-self: flex-end; /* Align download button to the right */\n    margin-top: 10px;\n  }\n  .broucher-info h2\n  {\n    font-size: 20px;\n  }\n \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
